

































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import PartEntity from '@/entities/Part';
import PartService from '@/services/part';
import Icon from '@/components/Icon.vue';
import FloatLabelInput from '@/components/FloatLabelInput.vue';
import Picture from '@/entities/Picture';
import variables from '@/support/variables';
import PictureService from '@/services/picture';

@Component({
  components: {
    FloatLabelInput,
    Icon,
    VueUploadMultipleImage,
  },
})
export default class Part extends Vue {
  partService = new PartService();

  pictureService = new PictureService();

  part: PartEntity = null;

  loadUploader = true;

  showPicturesSorting = false;

  sortedItems: any = null;

  status: string = null;

  numberOfImagesBeingProcessed = 0;

  statuses = [
    { name: 'Verkocht', value: 'sold' },
    { name: 'Gereserveerd', value: 'reserved' },
  ];

  get variables() {
    return variables;
  }

  get thumbnails(): string[] {
    const end = this.part.pictures.length < 5 ? this.part.pictures.length : 5;

    return this.part.pictures
      .slice(1, end)
      .map((picture: Picture) => picture.thumb320Url);
  }

  mounted() {
    if (this.$route.params.id) {
      this.partService.get(this.$route.params.id)
        .then((part: PartEntity) => {
          this.part = part;
          if (this.part.isReserved) {
            this.status = 'reserved';
          } else if (this.part.isSold) {
            this.status = 'sold';
          }
        });
    } else {
      this.part = new PartEntity();
    }
  }

  uploadImageSuccess(formData: any, index: any, fileList: any) {
    this.numberOfImagesBeingProcessed += 1;
    this.pictureService.uploadData(fileList[index].path, fileList[index].name, 'parts')
      .then((picture: Picture) => {
        this.part.addPicture(picture);
      })
      .finally(() => {
        this.numberOfImagesBeingProcessed -= 1;
      });
  }

  save() {
    this.partService.save(this.part)
      .then((part) => {
        this.$nextTick(() => this.$router.replace({
          name: 'Parts',
        }));
      });
  }

  orderChanged(sorted: any) {
    this.sortedItems = sorted.items;
  }

  @Watch('numberOfImagesBeingProcessed')
  reloadUploader(numberOfImagesBeingProcessed: number) {
    if (numberOfImagesBeingProcessed === 0) {
      this.loadUploader = false;

      this.$nextTick(() => {
        this.loadUploader = true;
      });
    }
  }

  @Watch('showPicturesSorting')
  populateOrder(showPicturesSorting: boolean) {
    if (!showPicturesSorting && this.sortedItems) {
      this.$nextTick(() => {
        this.part.pictures = this.sortedItems.map((item: any) => {
          const picture = item.item;
          picture.position = item.sort + 1;
          return picture;
        });
        this.sortedItems = null;
      });
    }
  }

  @Watch('status')
  statusChanged(status: string) {
    if (status === 'sold') {
      this.part.isSold = true;
      this.part.isReserved = false;
    } else if (status === 'reserved') {
      this.part.isSold = false;
      this.part.isReserved = true;
    } else {
      this.part.isSold = false;
      this.part.isReserved = false;
    }
  }
}
